const sharedMobileDesktop = require('../pages/content/comingSoon_EN.js');

export default {
  large: [
    {
      scrolledSection: {
        sectionType: 'text',
        data: {
          headline: sharedMobileDesktop.headline,
          text: sharedMobileDesktop.text,
        },
      },
    }
  ],

};



// WEBPACK FOOTER //
// ./pages/ComingSoon.js